export const error = {
  validation: {
    isString: 'Must be a string',
    isUrl: 'Must be an url',
    isOptional: 'Is optional',
    isBoolean: 'Must be a boolean value',
    isEnum: 'Must be a valid enum value',
    validateNested: 'Nested property validation failed',
    isNumber: 'Must be a number',
    isDate: 'Must be a Date instance',
    isArray: 'Must be an array',
    isObject: 'Must be an object',
    arrayMaxSize: 'Must contain no more than {{max}} elements',
    isNotEmpty: 'Should not be empty',
    maxLength: 'Must be shorter than or equal to {{max}} characters',
    isUUID: 'Must be a UUID',
    arrayMinSize: 'Must contain at least {{min}} elements',
    min: 'Must not be less than {{min}}',
    equals: 'Should be equal to {{value}}',
    notEquals: 'Should not be equal to {{value}}',
    isDecimal: 'Must be a decimal number',
    arrayUnique: 'All elements must be unique',
    isEmail: 'Invalid email address',
    isNumberString: 'Must be a number string',
    isFQDN: 'Must be a fully qualified domain name',
    isInt: 'Must be an integer',
    minLengthIfNotEmpty: '$property must be at least $constraint1 characters',
    sumArrayItemsPropertyEquals:
      'Sum of $property[...].$constraint1 must be equals $constraint2',
    customValidateName: 'The name does not meet the requirements',
    customValidatePassword: 'The password does not meet the requirements',
    isEqualTo: '{{property}} must match {{relatedProperty}} exactly',
    isLuhnCardNumber: 'Invalid card number',
  },
  custom: {
    invalidPromoCode: 'Invalid promo code',
    expiredPromoCode: 'Promo code has expired',
    activatedPromoCode: 'You have already activated this promo code',
    passwordEqual: 'Passwords should be equal',
    agreementRequired: 'Agreement to terms is required',
    emailUsed: 'Email already in use',
    emailVerificationUnavailable:
      'Unable to verify this email address right now. Please try again later.',
    nameUsed: 'Username already in use',
    registrationEmailNotAllowed:
      'Unable to register with this email address. Please try another one.',
    emailNotFound: 'Email address not found',
    wrongPassword: 'Wrong password',
    tooManyLogin: 'Too many failed login attempts. Please try again later.',
    emailNotActivated: 'Email not activated.',
    restoreLinkNotFound: 'Restore link not found',
    passwordShouldDiffer: 'Password should differ from the previous one',
    incorrectActivationLink: 'Incorrect activation link.',
    tooManyFailedAttempts:
      'Too many failed attempts. Please try to activate it later.',
    expiredActivationLink: 'Expired activation link was used',
    emailAlreadyActivated: 'Email already activated',
    authTokenMissing: 'Authorization token is missing',
    tokenNotValid: 'Token is not valid',
    subscriptionNotFound: 'Subscription not found',
    subscriptionExceeded: 'Subscription exceeded',
    minimumDepositAmount: 'Minimum deposit amount is $5',
    minimumWithdrawalAmount: 'Minimum withdrawal amount is $50',
  },
};
